"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHostTerminalReducer = exports.updateTerminalOfflineReducer = exports.createTerminalOfflineReducer = exports.fetchTerminalOfflineReducer = exports.createHostTerminalSlice = exports.updateTerminalOfflineSlice = exports.createTerminalOfflineSlice = exports.fetchTerminalOfflineSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const terminalOfflineAction_1 = require("./terminalOfflineAction");
const fetchInitialState = {
    loading: false,
    error: null,
    data: []
};
const createInitialState = {
    loading: false,
    error: null,
    data: []
};
const updateInitialState = {
    loading: false,
    error: null,
    data: []
};
const createHostInitialState = {
    loading: false,
    error: null,
    data: []
};
exports.fetchTerminalOfflineSlice = (0, toolkit_1.createSlice)({
    name: 'terminalOffline/fetch',
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(terminalOfflineAction_1.fetch.pending, (state) => {
            state.loading = true;
            state.data = [];
            state.error = null;
        })
            .addCase(terminalOfflineAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        })
            .addCase(terminalOfflineAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.data = [];
            state.error = action.error.message;
        });
    }
});
exports.createTerminalOfflineSlice = (0, toolkit_1.createSlice)({
    name: 'terminalOffline/create',
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(terminalOfflineAction_1.create.pending, (state) => {
            state.loading = true;
            state.data = [];
            state.error = null;
        })
            .addCase(terminalOfflineAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        })
            .addCase(terminalOfflineAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.data = [];
            state.error = action.error.message;
        });
    }
});
exports.updateTerminalOfflineSlice = (0, toolkit_1.createSlice)({
    name: 'terminalOffline/update',
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(terminalOfflineAction_1.update.pending, (state) => {
            state.loading = true;
            state.data = [];
            state.error = null;
        })
            .addCase(terminalOfflineAction_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        })
            .addCase(terminalOfflineAction_1.update.rejected, (state, action) => {
            state.loading = false;
            state.data = [];
            state.error = action.error.message;
        });
    }
});
exports.createHostTerminalSlice = (0, toolkit_1.createSlice)({
    name: 'terminalOffline/createHost',
    initialState: createHostInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(terminalOfflineAction_1.createHost.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(terminalOfflineAction_1.createHost.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(terminalOfflineAction_1.createHost.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.fetchTerminalOfflineReducer = exports.fetchTerminalOfflineSlice.reducer;
exports.createTerminalOfflineReducer = exports.createTerminalOfflineSlice.reducer;
exports.updateTerminalOfflineReducer = exports.updateTerminalOfflineSlice.reducer;
exports.createHostTerminalReducer = exports.createHostTerminalSlice.reducer;
